import appConfig from '../../config/appConfig';
import AssetTypes from '../../api/AssetTypes';

const filterData = {
  namespaced: true,
  state: {
    assetTypes: null,
    assetTypesLoaded: false,
    locations: null,
    locationsLoaded: false,
    facilities: null,
    facilitiesLoaded: false,
    statusValues: null,
    statusValuesLoaded: false,
    mapFilterEnergy: undefined,
    mapFilterStatus: undefined
  },
  mutations: {
    setAssetTypes(state, assetTypes) {
      state.assetTypes = assetTypes;
    },
    setAssetTypesLoaded(state, loaded) {
      state.assetTypesLoaded = loaded;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
    setLocationsLoaded(state, loaded) {
      state.locationsLoaded = loaded;
    },
    setFacilities(state, facilities) {
      state.facilities = facilities;
    },
    setFacilitiesLoaded(state, loaded) {
      state.facilitiesLoaded = loaded;
    },
    setStatusValues(state, statusValues) {
      state.statusValues = statusValues;
    },
    setStatusValuesLoaded(state, loaded) {
      state.statusValuesLoaded = loaded;
    },
    setMapFilterEnergy(state, value) {
      state.mapFilterEnergy = value;
    },
    setMapFilterStatus(state, value) {
      state.mapFilterStatus = value;
    }
  },
  getters: {
    assetTypes: (state) => {
      return state.assetTypes;
    },
    assetTypesLoaded: (state) => {
      return state.assetTypesLoaded;
    },
    locations: (state) => {
      return state.locations;
    },
    locationsLoaded: (state) => {
      return state.locationsLoaded;
    },
    facilities: (state) => {
      return state.facilities;
    },
    facilitiesLoaded: (state) => {
      return state.facilitiesLoaded;
    },
    statusValues: (state) => {
      return state.statusValues;
    },
    statusValuesLoaded: (state) => {
      return state.statusValuesLoaded;
    },
    searchables: (state) => {
      const facilitiesAppended = state.facilities
        .map((f) => ({
          ...f,
          type: 'Facility',
          displayname: f.name
        }))
        .sort((a, b) => a.displayname > b.displayname);
      const locationsAppended = state.locations
        .map((l) => ({
          ...l,
          type: 'Geography',
          displayname: l.state
        }))
        .sort((a, b) => a.displayname > b.displayname);
      const combined = [...locationsAppended, ...facilitiesAppended];
      return combined;
    },
    mapFilterEnergy(state) {
      return state.mapFilterEnergy;
    },
    mapFilterStatus(state, value) {
      return state.mapFilterStatus;
    },
    mapFilterEnergyClause(state) {
      if (!state.mapFilterEnergy) {
        return '1=1';
      }
      const inClause = state.mapFilterEnergy
        .map((item) => {
          return "'" + item + "'";
        })
        .join(',');
      let filter = appConfig.filterColumns.assetType + ' IN (' + inClause + ')';
      if (filter.indexOf('Null') > -1) {
        filter =
          '(' +
          filter +
          ' OR ' +
          appConfig.filterColumns.assetType +
          ' IS NULL)';
      }
      return filter;
    },
    mapFilterStatusClause(state) {
      if (!state.mapFilterStatus) {
        return '1=1';
      }
      const inClause = state.mapFilterStatus
        .map((item) => {
          return "'" + item + "'";
        })
        .join(',');
      let filter =
        appConfig.filterColumns.statusType + ' IN (' + inClause + ')';
      if (filter.indexOf('Null') > -1) {
        filter =
          '(' +
          filter +
          ' OR ' +
          appConfig.filterColumns.statusType +
          ' IS NULL)';
      }
      return filter;
    }
  },
  actions: {
    async fetchAssetTypes({ commit }) {
      const get = async () => {
        const assetTypes = new AssetTypes(appConfig.assetTypeApiProps);
        await assetTypes
          .getAssetTypes()
          .then((result) => {
            commit('setAssetTypes', result);
            commit('setAssetTypesLoaded', true);
          })
          .catch((err) => {
            console.log(`Error getting asset types:`);
            console.log(err);
            commit('setError', 'Asset Types: ' + err.message, {
              root: true
            });
          });
      };
      get();
    },
    async setFilterItem(
      { commit, state, getters },
      { filterValue, filterType }
    ) {
      const filter = async (filterType, filterValue) => {
        if (filterType === 'energy') {
          commit('setMapFilterEnergy', filterValue);
        }
        if (filterType === 'status') {
          commit('setMapFilterStatus', filterValue);
        }
      };
      filter(filterType, filterValue);
    }
  }
};

export default filterData;
